import { createComponent } from '@carvana/merch-components';
import flattenWhiteSpace from '~/utilities/flattenWhiteSpace';

type OwnProps = React.PropsWithChildren<{
  className?: string;
}>;

const StyledPill = createComponent('div', {
  className: flattenWhiteSpace(
    `bg-white border border-solid border-grey-2
    flex min-h-[32px] items-center py-6 px-12 rounded-[100px]
    t-body-s text-blue-6`
  )
});

const Pill = ({ className, children }: OwnProps) => (
  <StyledPill className={className}>{children}</StyledPill>
);

export default Pill;
